<template>
    <div class="home">
        <b-container fluid>
            <b-row>
              <b-col>
                <h1>Unclaimed Certificate Information Change Review</h1>
              </b-col>
            </b-row>

            <div class="card">
                <div class="card-header">Review</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Current Assignee" :value="change.assignedName"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Assigned Date" :value="change.assignedDate"/></b-col>
                        <b-col cols="4" v-if="!isAssigned"><b-button variant="success" class="mr-4" @click="reassign">Assign To Me</b-button></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Last Name" :value="change.lastName"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="First Name" :value="change.firstName"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Middle Name" :value="change.middleName"/></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="SSN" :value="change.ssn"/></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Phone" :value="change.phone"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Email" :value="change.email"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Date of Birth" :value="formatDate(change.dateOfBirth)"/></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Certificate Number" :value="change.certificateNumber"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Approved Certificate Number" :value="change.approvedCertificateNumber"/></b-col>
                    </b-row>

                    <b-row >
                        <b-col>
                            <h2 class="mt-4">Attachments</h2>
                            <AttachmentList type="unclaimed" :value="attachments"/>
                        </b-col>
                    </b-row>

                    <b-row class="mt-1" v-if="isReceived && isAssigned">
                        <b-col cols="12">
                            <b-button variant="success" class="mr-4" @click="showApproveModal">Approve Change</b-button>
                            <b-button variant="danger" class="mr-2" @click="showDenyModal">Deny Change</b-button>
                        </b-col>
                    </b-row>
              </div>
            </div>

        </b-container>

        <b-modal id="approve-modal" hide-header hide-footer>
            <h2>Approve Change</h2>
            <hr/>
            <form ref="form" @submit.prevent="approve">
                You are about to approve the changes.
                <p class="mt-2">Press Confirm to approve or Cancel to return to the application review.</p>
                <div>
                    <BaseTextInput v-model="mdhApprovedCertificateNumber"
                                   :v="$v.mdhApprovedCertificateNumber"
                                   label="Certificate Number to be Updated"
                                   slug="number"
                                   setId="number"/>
                </div>
                <div>
                    <b-button @click="closeApproveModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
        <b-modal id="deny-modal" hide-header hide-footer>
            <h2>Deny Change</h2>
            <hr/>
            <form ref="form" @submit.prevent="deny">
                You are about to deny these changes.
                <p class="mt-2">Press Confirm to deny or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeDenyModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { required } from 'vuelidate/lib/validators'
import AttachmentList from '@/components/templates/display/AttachmentList.vue'
import {toastService} from "@/mixins/toastService"
import moment from 'moment'
import BaseTextOutput from "../../components/templates/input/BaseTextOutput.vue";

axiosRetry(axios, { retries: 0,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
    components: {
      BaseTextOutput,
        AttachmentList
    },

    data: () => ({
        change: {},
        attachments: [],
        mdhApprovedCertificateNumber: null,
    }),

    mounted() {
        this.loadChange()
    },

    methods: {
        loadChange() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/change/unclaimed/${this.$route.params.id}`)
                .then(response => {
                    this.attachments = []
                    this.change = response.data
                    if (this.change.nameAttachment != null) {
                        this.attachments.push(this.change.nameAttachment)
                    }
                    if (this.change.ssnAttachment != null) {
                        this.attachments.push(this.change.ssnAttachment)
                    }
                    if (this.change.dobAttachment != null) {
                        this.attachments.push(this.change.dobAttachment)
                    }
                })
        },
        showApproveModal() {
            this.$bvModal.show('approve-modal')
        },
        closeApproveModal() {
            this.$bvModal.hide('approve-modal')
        },
        showDenyModal() {
            this.$bvModal.show('deny-modal')
        },
        closeDenyModal() {
            this.$bvModal.hide('deny-modal')
        },
        approve() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                let payload = {
                    id: this.$route.params.id,
                    certificateNumber: this.mdhApprovedCertificateNumber,
                }
                this.submitToServer('approve', payload)
            }
        },
        deny() {
            this.submitToServer('deny', this.$route.params.id)
        },
        submitToServer(action, payload) {
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/change/unclaimed/${action}`, payload)
            .then(response => {
               toastService.showRootToast("Updated", "Your decision has been updated.", "success", this.$root)
               this.$router.push('/home')
          }).catch(error => {
              toastService.showRootToast("Error", "An error has occurred while processing your request", "danger", this.$root)
          })
        },
        formatDate(unformattedDate){
            let formattedDate = moment(unformattedDate);
            if(!formattedDate.isValid()) return '';
            return formattedDate.format("MM/DD/YYYY")
        },
        reassign() {
            let payload = {
                id: this.change.id,
                assignedName: this.$keycloak.subject,
                type: this.change.assignType.code
            }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/assign`, payload)
                    .then(response => {
                        this.loadChange()
                        toastService.showRootToast("Assigned", "Credentialer has been assigned.", "success", this.$root)
                    }) .catch(error => {
                    toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
                })
        }
    },
    validations() {
        return {
            mdhApprovedCertificateNumber: { required },
        }
    },
    mixins: [
        toastService
    ],
    created() {
        document.title = "Unclaimed Certificate Information Change Review - NAR"
    },
    computed: {
        isReceived() {
            return this.change.status === 'Received'
        },
        isAssigned() {
            return this.$keycloak.authenticated && this.$keycloak.subject === this.change.assigned
        },
    }
}
</script>

<style>
</style>